import {useTranslation} from 'react-i18next';
import DateInput from '../../../../component/input/dateInput/DateInput';
import {useField} from 'formik';
import {useSelector} from 'react-redux';
import {useContext} from 'react';
import * as css from '../dateStep/DateStep.css';
import {stopEnterKeyDown} from '../Step/Step';
import {newEventContext} from '../newEventForm/NewEventForm';
import setGlobalState from '../../../../redux/setGlobalState';
import getCountryByTimeZone from '../../../../library/getCountryByTimeZone';
import CountryFlag from '../../../../component/countryFlag/CountryFlag';
import store from '../../../../store';
import {addMinute, combineDateTime, getTs, checkIfToday as isToday, getStartOfDay, getEndOfDay} from '../../../../library/dates';
import { updateEvent } from '../../../../redux/event/eventActions';
import getUnequalFields from '../../../../functions/getUnequalFields';

export const onClickSimpleDate = async (_changedValues, date, form) => {
    let fields;
    if(!date.startDate)
        fields={
            timeStart:null,
            timeEnd:null,
        };
    else {
        const timeZone = form.values.locale.timeZone;
        const defaultStartTime = date.startTime || (
            isToday(date.startDate, timeZone)
                ? addMinute(getTs(null, timeZone), 10, timeZone)
                : getStartOfDay(date.startDate, timeZone)
        );
        const defaultEndTime = date.endTime || (date.endDate && getEndOfDay(date.endDate, timeZone));
        fields={
            timeStart:combineDateTime(date.startDate,defaultStartTime,timeZone)||null,
            timeEnd:defaultEndTime ? combineDateTime(date.endDate,defaultEndTime,timeZone)||null : null,
            timeOpen:date.timeOpen?combineDateTime(date.startDate,date.timeOpen,timeZone):null,
        };
    }
    const {timeStart,timeEnd}=store.getState().event;
    const oldDate={timeStart,timeEnd};
    const changedValues=getUnequalFields({date:oldDate},{date:fields});
    if(!changedValues.date){
        return Promise.resolve();
    }

    await updateEvent(fields);};

interface SimpleDateStepProps {
    startDateText?: string;
    endDateText?: string;
}

function SimpleDateStep({startDateText = 'startDate', endDateText = 'endDate'}: SimpleDateStepProps) {
    const {t} = useTranslation('newEvent');
    const [{value: timezone}] = useField('locale.timeZone');
    const [{value: startDate}] = useField('date.startDate');
    const {isReady} = useContext(newEventContext);
    const isOpenLocaleStep = useSelector((s: any) => s.ui.event.isOpenLocaleStep);

    return (
        <css.wrapper onKeyDown={stopEnterKeyDown}>
            <DateInput
                name="date.startDate"
                timezone={timezone}
                text={t(startDateText)}
                isFixed={true}
                className={undefined}
                descText={undefined}
                onChange={undefined}
                readOnly={undefined}
                icon={undefined}
            />
            <DateInput
                name="date.endDate"
                timezone={timezone}
                text={t(endDateText)}
                isFixed={true}
                datePickerProps={{minDate: startDate}}
                className={undefined}
                descText={undefined}
                onChange={undefined}
                readOnly={undefined}
                icon={undefined}
            />
            <css.timeZoneWrap>
                <css.timeZoneAndLang
                    className={`${isReady ? 'ready' : ''} ${isOpenLocaleStep ? 'open' : ''}`}
                    onClick={isReady ? undefined : () => setGlobalState('ui.event.isOpenLocaleStep', !isOpenLocaleStep)}>
                    {`${isOpenLocaleStep ? t('hide') : ''} ${t(isReady ? 'localeHeader' : 'timeZoneLangOptions')}`}
                    <CountryFlag countryCode={getCountryByTimeZone(store.getState().event.timeZone, false).toLowerCase()} />
                </css.timeZoneAndLang>
            </css.timeZoneWrap>
        </css.wrapper>
    );
}

export default SimpleDateStep;

